package one.healthium.onboarding.ui.screens

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.util.fastForEachIndexed
import one.healthium.bundle.components.BundleImage
import one.healthium.onboarding.domain.configs.CalculatingPersonalPlanScreenConfig
import one.healthium.onboarding.domain.models.Slider
import one.healthium.onboarding.ui.UserDataProvider
import one.healthium.onboarding.ui.UserProfileUiModel
import one.healthium.onboarding.ui.bindPlaceholderValues
import one.healthium.onboarding.ui.components.ProgressSlider
import one.healthium.ui.components.ReviewsPager
import one.healthium.ui.compose.components.AppScaffold
import one.healthium.ui.compose.components.AppText
import one.healthium.ui.compose.theme.AppTheme

interface CalculatingPersonalPlanEventDelegate {
    fun onNextClicked()
}

@Composable
internal fun CalculatingPersonalPlanScreen(
    eventDelegate: CalculatingPersonalPlanEventDelegate,
    screenConfig: CalculatingPersonalPlanScreenConfig,
) {
    UserDataProvider { userState, _ ->
        AppScaffold {
            CalculatingPersonalPlanScreenContent(
                screenConfig = screenConfig,
                userState = userState,
                onNextClicked = eventDelegate::onNextClicked,
            )
        }
    }
}

@Composable
internal fun CalculatingPersonalPlanScreenContent(
    modifier: Modifier = Modifier,
    screenConfig: CalculatingPersonalPlanScreenConfig,
    userState: UserProfileUiModel,
    onNextClicked: () -> Unit,
) {
    Column(
        modifier = modifier
            .fillMaxSize()
            .navigationBarsPadding()
            .verticalScroll(rememberScrollState()),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Box(
            modifier = Modifier.fillMaxWidth(),
        ) {
            BundleImage(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(276.dp),
                name = screenConfig.header,
                contentScale = ContentScale.FillBounds,
            )
            AppText(
                modifier = Modifier
                    .fillMaxWidth()
                    .statusBarsPadding()
                    .padding(top = 20.dp)
                    .padding(horizontal = 24.dp),
                text = screenConfig.title?.bindPlaceholderValues(userState),
                style = AppTheme.textStyles.title,
                color = AppTheme.colors.textInverted100,
                textAlign = TextAlign.Center,
            )
        }
        Spacer(Modifier.weight(1f))
        SlidersGroup(
            sliders = screenConfig.sliders,
            onFinished = onNextClicked,
        )
        Spacer(Modifier.height(10.dp))
        ReviewsPager(reviews = screenConfig.reviews)
        Spacer(Modifier.weight(1f))
    }
}

@Composable
private fun SlidersGroup(
    sliders: List<Slider>,
    onFinished: () -> Unit,
) {
    var activeSlider by remember { mutableIntStateOf(0) }
    sliders.fastForEachIndexed { index, slider ->
        ProgressSlider(
            modifier = Modifier.padding(horizontal = 24.dp),
            slider = slider,
            autoStart = activeSlider == index,
            onFinished = {
                activeSlider += 1
                if (activeSlider == sliders.size) {
                    onFinished()
                }
            }
        )
        Spacer(Modifier.height(38.dp))
    }
}
